import '@/assets/scripts/loader_static.js';

import { createGtm } from '@gtm-support/vue-gtm';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { MotionPlugin } from '@vueuse/motion';
import { Amplify } from 'aws-amplify';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import { getConfig } from '@/utils/awsAmplify';

import App from './App.vue';
import router from './router';
import { initDatadog } from './utils/datadog/init';
import { initialiseFeatures } from './utils/features';

const store = createPinia();

const gtmConfig = createGtm({
  id: 'GTM-T3V4FN',
  compatibility: true,
  debug: false,
  loadScript: true,
  vueRouter: router as any,
  trackOnNextTick: true,
});

const config = getConfig();

const isDev = import.meta.env.MODE === 'development';
const proxyEnv = import.meta.env.VITE_PROXY_ENV;
const useMocks = import.meta.env.VITE_USE_MOCKS === 'true';

if (isDev && proxyEnv) {
  const match = window.location.hash.match(/devTokens=([^&]+)/);
  if (match) {
    try {
      const tokens = JSON.parse(atob(match[1]));
      Object.entries(tokens).forEach(([k, v]) => localStorage.setItem(k, v as string));
    } catch { /* ignore malformed tokens */ }
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }
}

Amplify.configure(config);

if (!proxyEnv && isDev && useMocks) {
  const { startMockWorker } = await import('./api/mocks/browser');

  await startMockWorker();
}

const app = createApp(App);
initDatadog(app);
app.use(VueQueryPlugin).use(router).use(store);
initialiseFeatures();

if (import.meta.env.MODE === 'production' || import.meta.env.VITE_USE_MOCKS === 'true') {
  app.use(gtmConfig);
}

app.use(MotionPlugin);

app.mount('#app');
